// 采集当前页面路由和在线状态，作为所有监控事件的基础上下文。
const getRouteMeta = () => {
  if (typeof window === 'undefined') {
    return {}
  }

  return {
    route_path: window.location?.pathname ?? '',
    route_search: window.location?.search ?? '',
    route_hash: window.location?.hash ?? '',
    online: typeof navigator !== 'undefined' ? navigator.onLine : undefined,
  }
}

// 只区分游客和已登录，避免在监控里带入过多用户隐私信息。
const getAuthState = () => {
  try {
    return localStorage.token ? 'login' : 'guest'
  } catch {
    return 'unknown'
  }
}

// locale 同样通过安全读取获取，避免在非浏览器环境直接访问 localStorage。
const getStoredLocale = () => {
  try {
    return localStorage.locale ?? ''
  } catch {
    return ''
  }
}

// 过滤掉 undefined / null / 空字符串，避免监控字段噪音。
const pickDefinedEntries = (record = {}) => {
  return Object.fromEntries(
    Object.entries(record).filter(([, value]) => value !== undefined && value !== null && value !== '')
  )
}

// 统一把 tags 写入 Sentry scope。
const setScopeTags = (scope, tags = {}) => {
  Object.entries(tags).forEach(([key, value]) => {
    scope.setTag(key, String(value))
  })
}

// 统一把 extra 写入 Sentry scope。
const setScopeExtra = (scope, extra = {}) => {
  Object.entries(extra).forEach(([key, value]) => {
    scope.setExtra(key, value)
  })
}

// 统一把结构化 context 写入 Sentry scope。
const setScopeContexts = (scope, contexts = {}) => {
  Object.entries(contexts).forEach(([key, value]) => {
    scope.setContext(key, value)
  })
}

// 生成所有事件都会自动携带的基础元信息。
export const getMonitorBaseMeta = () => {
  const routeMeta = getRouteMeta()

  return {
    tags: pickDefinedEntries({
      platform: globalThis.platform ?? 'h5',
      project: globalThis.proj ?? '',
      locale: getStoredLocale(),
      auth_state: getAuthState(),
      route_path: routeMeta.route_path,
    }),
    extra: pickDefinedEntries(routeMeta),
  }
}

// 把基础上下文和调用方传入的 meta 合并后写入 scope。
// 这样 infra/domain 层只关心补充字段，不需要重复拼公共上下文。
export const applyMonitorScope = (scope, meta = {}) => {
  const baseMeta = getMonitorBaseMeta()
  const tags = pickDefinedEntries({
    ...baseMeta.tags,
    ...meta.tags,
  })
  const extra = pickDefinedEntries({
    ...baseMeta.extra,
    ...meta.extra,
  })

  setScopeTags(scope, tags)
  setScopeExtra(scope, extra)
  setScopeContexts(scope, meta.contexts)

  if (meta.level) {
    scope.setLevel(meta.level)
  }

  if (Array.isArray(meta.fingerprint) && meta.fingerprint.length) {
    scope.setFingerprint(meta.fingerprint.map(item => String(item)))
  }

  if (meta.user) {
    scope.setUser(meta.user)
  }
}
